// Shared Framer Motion variant presets — hoisted to module scope so prop
// objects keep stable identity across renders.

// Pixel offsets used by the entrance variants.
const Y_OFFSET_LG = 30;
const Y_OFFSET_SM = 20;
const Y_OFFSET_XS = 10;
const X_OFFSET = 20;
const X_OFFSET_LG = 40;

export const fadeUp = {
  initial: { opacity: 0, y: Y_OFFSET_LG },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
};

export const fadeUpSmall = {
  initial: { opacity: 0, y: Y_OFFSET_SM },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

export const fadeIn = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true },
};

export const fadeRight = {
  initial: { opacity: 0, x: -X_OFFSET_LG },
  whileInView: { opacity: 1, x: 0 },
  viewport: { once: true },
};

export const heroSlide = {
  initial: { opacity: 0, y: Y_OFFSET_LG },
  animate: { opacity: 1, y: 0 },
};

export const heroSlideX = {
  initial: { opacity: 0, x: X_OFFSET },
  animate: { opacity: 1, x: 0 },
};

export const fadeInUp = {
  initial: { opacity: 0, y: Y_OFFSET_XS },
  animate: { opacity: 1, y: 0 },
};

export const simpleFade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
};

export const overlayTrans = { duration: 0.6 };

export const easeOutExpo = [0.22, 1, 0.36, 1];

export const trans = (duration = 0.8, delay = 0) => ({ duration, delay, ease: easeOutExpo });

// Shared status message components live in StatusMessage.jsx for reuse.
